export enum PermissionsEnum {
  Permissions = 'Uprawnienia',
  Administration = 'Administracja',
  Clients = 'Kontrahenci',
  Finance = 'Finanse',
  FinanceAdministration = 'Finanse administracja',
  FinanceClients = 'Finanse kontrahenci',
  Projects = 'Kampanie/Projekty',
  Surveys = 'Ankiety',
}
